/** Manual theme with an "auto" default that follows the system. Persisted per browser. */
export type ThemeMode = "auto" | "light" | "dark";
const KEY = "sekani.theme";
const COLORS = { light: "#fffefa", dark: "#0b0b0a" };

export function readTheme(): ThemeMode {
  try { const v = localStorage.getItem(KEY); return v === "light" || v === "dark" ? v : "auto"; } catch { return "auto"; }
}

export function applyTheme(mode: ThemeMode): void {
  const root = document.documentElement;
  if (mode === "auto") root.removeAttribute("data-theme"); else root.setAttribute("data-theme", mode);
  try { if (mode === "auto") localStorage.removeItem(KEY); else localStorage.setItem(KEY, mode); } catch { /* private mode */ }
  const dark = mode === "dark" || (mode === "auto" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", dark ? COLORS.dark : COLORS.light);
}
